import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { DropzoneArea } from "material-ui-dropzone";
import { uploadTicketDocument } from "../../utilities/imageTestApi/image";
import { ExtractTrainTicketFromImage } from "../../entities/action/action";
import { mapExtractedToTicket } from "./trainTicketConstants";
import classes from "./ticketGenerator.module.css";

const ACCEPTED = ["image/*", "application/pdf", ".pdf"];

const TrainTicketUpload = ({ onExtracted }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleUpload = async (files) => {
    if (!files || !files.length) return;
    const file = files[0];
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const documentUrl = await uploadTicketDocument(file);
      const res = await ExtractTrainTicketFromImage({ imageUrl: documentUrl });
      if (res?.success && res?.aiResponse) {
        console.log("[TrainTicket Extract]", res.aiResponse);
        onExtracted(mapExtractedToTicket(res.aiResponse));
        setSuccess("Ticket details extracted. Review and edit before saving.");
      } else {
        setError(res?.message || "Could not extract ticket details from the file.");
      }
    } catch (e) {
      setError(e.message || "Upload or extraction failed. Try a JPG/PNG image or PDF.");
    }
    setLoading(false);
  };

  return (
    <div className={classes.Box}>
      <h5>Automated Ticket Generator</h5>
      <p className={classes.Hint}>
        Upload a train ticket or booking confirmation as an image (JPG, PNG) or PDF.
        AI will extract details into the form for review.
      </p>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}
      <DropzoneArea
        filesLimit={1}
        acceptedFiles={ACCEPTED}
        dropzoneText="Drag & drop a ticket image or PDF, or click to browse"
        onChange={handleUpload}
        showPreviews
        showAlerts={false}
      />
      {loading && <p className={classes.Hint}>Uploading and extracting ticket information...</p>}
    </div>
  );
};

export default TrainTicketUpload;
